export default __webpack_public_path__ + "fonts/detail_1.599a42b388621c115b15ef526c0d6553.png";